import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import VoucherFormModal from 'src/features/vouchers/components/forms/VoucherFormModal';
import { vouchersMessages } from 'src/features/vouchers/utils/messages';
import { LIST_VOUCHERS_RESOURCE } from 'src/features/vouchers/api/useListVouchers';
import { VOUCHER_RESOURCE } from 'src/features/vouchers/api/useGetVoucher';
import { useCreateVoucher } from 'src/features/vouchers/api/useCreateVoucher';

interface CreateVoucherFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateVoucherFormModal<TData>({ className, semantics }: CreateVoucherFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreateVoucher({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_VOUCHERS_RESOURCE] });
            void queryClient.invalidateQueries({ queryKey: [VOUCHER_RESOURCE] });
            toast({
                title: formatMessage(vouchersMessages.createVoucherSuccess),
                description: formatMessage(vouchersMessages.createVoucherSuccessDescription),
            });
        },
    });

    return (
        <VoucherFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(vouchersMessages.addVoucherSubtitle)}
        />
    );
}

export default CreateVoucherFormModal;
